module.exports = __webpack_public_path__ + "static/media/pedraza.ecb51e66.png";